import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpsInputComponent } from '../ops-input/ops-input.component';
import { OpsSelectComponent } from '../ops-select/ops-select.component';
import { OpsProfileSettingsComponent } from './ops-profile-settings.component';
import { OpsSettingsAddButtonComponent } from '../ops-settings-add-button/ops-settings-add-button.component';
import { NgxsModule } from '@ngxs/store';
import { SettingsEditState } from '@ops/services';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { OpsAddAdditionalMediaChannelComponent } from '../ops-add-additional-media-channel/ops-add-additional-media-channel.component';
import { OpsCalendarComponent } from '../ops-calendar/ops-calendar.component';
import { OpsInputWithListItemsComponent } from '../ops-input-with-list-items/ops-input-with-list-items.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    OpsInputComponent,
    OpsInputWithListItemsComponent,
    OpsSelectComponent,
    OpsSettingsAddButtonComponent,
    OpsAddAdditionalMediaChannelComponent,
    OpsCalendarComponent,
    TranslateModule,
    NgxsModule.forRoot([SettingsEditState]),
    NgxsReduxDevtoolsPluginModule.forRoot(),
  ],
  declarations: [OpsProfileSettingsComponent],
  exports: [OpsProfileSettingsComponent],
})
export class OpsProfileSettingsModule {}
